import { render, staticRenderFns } from "./Privacyinfo.vue?vue&type=template&id=c0649b74&scoped=true&"
import script from "./Privacyinfo.vue?vue&type=script&lang=js&"
export * from "./Privacyinfo.vue?vue&type=script&lang=js&"
import style0 from "./Privacyinfo.vue?vue&type=style&index=0&id=c0649b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0649b74",
  null
  
)

/* custom blocks */
import block0 from "./Privacyinfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports